<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import type {Pages_V1} from "#magnolia-layer/types/api";
import {usePagesByIds} from "~/composables/usePages";
import {PhArrowRight} from "@phosphor-icons/vue";
const props = defineProps<{
  metadata: Area;
  articles?: string[];
}>();

const {data: articles, error: articlesError} = await useAsyncData<
  Pages_V1 | undefined
>(props.metadata["@id"] + "_relatedArticles", () => {
  return props.articles
    ? usePagesByIds(props.articles)
    : Promise.resolve(undefined);
});

const pageLink = (path: string) => {
  return stripPrefix(path);
};
</script>

<template>
  <section
    v-if="articles && articles.results.length > 0"
    class="article-read-more_articles articles flex flex-col gap-16 mb-16">
    <h3 class="sr-only">Related articles</h3>
    <!-- Start article card -->
    <article
      class="flex flex-col lg:flex-row gap-6"
      v-for="(article, index) in articles?.results">
      <NuxtLinkLocale :to="pageLink(article['@path'])" class="text-[inherit]">
        <MagnoliaPicture
          :asset="article.image"
          :modifiers="{grayscale: 1}"
          loading="lazy"
          sizes="400 xs:640 lg:280">
        </MagnoliaPicture>
      </NuxtLinkLocale>
      <div class="article-body flex-1">
        <h1 class="uppercase font-sans font-bold mb-4">
          <NuxtLinkLocale
            :to="pageLink(article['@path'])"
            class="text-[inherit]">
            {{ article.title }}
          </NuxtLinkLocale>
        </h1>
        <p class="text-width-fit mb-2">{{ article.abstract }}</p>
        <NuxtLinkLocale
          :to="pageLink(article['@path'])"
          class="link-with-icon link-underline text-sunrise-200">
          <span>{{ $t("label.continueReading") }}</span>
          <PhArrowRight />
        </NuxtLinkLocale>
      </div>
    </article>
    <!-- End article card -->
  </section>
</template>

<style lang="scss" scoped></style>
